/* Base translations · Going concern — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): gc. */
export const I18N_BASE_GOING_CONCERN = {
  en: {
    gc: {
      option_1: "Conclusion 1 — going concern basis appropriate; no material uncertainty",
      option_2: "Conclusion 2 — material uncertainty, adequately disclosed",
      option_3: "Conclusion 3 — material uncertainty, inadequately disclosed",
      option_4: "Conclusion 4 — going concern basis inappropriate",
      option_5: "Conclusion 5 — management unwilling to assess",
      no_material_uncertainty: "No material uncertainty",
      impact: {
        opt1: "Conclusion 1 — Going concern basis is appropriate; no material uncertainty. Standard auditor's report (no going-concern paragraph).",
        opt2: "Unmodified opinion with a separate \"Material Uncertainty Related to Going Concern\" section. See 318(a) for report wording.",
        opt3: "Qualified or Adverse opinion, depending on the materiality and pervasiveness of the inadequate disclosure. See 318(a) for report wording.",
        opt4: "Adverse opinion. See 318(a) for report wording.",
        opt5: "Qualified opinion or Disclaimer of opinion, depending on the scope limitation. See 318(a) for report wording.",
        dateWarning: "Warning: the conclusion date is AFTER the auditor's report date. ISA 700 requires the auditor's report to be dated no earlier than the date on which the auditor has obtained sufficient appropriate audit evidence.",
        standardHint: "Standard applied is chosen from the period beginning date: period beginning BEFORE 15-Dec-2026 → ISA 570 (Revised) and the 12-month check runs from the FS date; ON or AFTER 15-Dec-2026 → ISA 570 (Revised 2024) and the 12-month check runs from the FS approval date.",
      },
      conclusion: {
        1: "Going concern basis is appropriate; no material uncertainty exists",
        2: "Going concern basis is appropriate; material uncertainty exists and disclosure is adequate",
        3: "Going concern basis is appropriate; material uncertainty exists and disclosure is inadequate",
        4: "Use of the going concern basis of accounting is not appropriate",
        5: "Management is unwilling or unable to make or extend its assessment",
      },
      standardApplied: "Standard applied",
      standardOverrideBanner: "You have overridden the auto-selected standard. Please record the reason below — the override is written to the audit trail.",
      reportingImpactLabel: "Reporting impact",
      reportingImpactEmpty: "No reporting impact — standard auditor's report.",
      reportingImpactLinkTo318a: "See 318(a) — Modified Opinion Assessment",
      additionalNotes: "Additional notes",
    },
  },
  ar: {
    gc: {
      option_1: "الاستنتاج 1 — أساس الاستمرارية مناسب؛ لا يوجد عدم تأكد جوهري",
      option_2: "الاستنتاج 2 — عدم تأكد جوهري مُفصح عنه بشكل كافٍ",
      option_3: "الاستنتاج 3 — عدم تأكد جوهري غير مُفصح عنه بشكل كافٍ",
      option_4: "الاستنتاج 4 — أساس الاستمرارية غير مناسب",
      option_5: "الاستنتاج 5 — الإدارة غير راغبة في إجراء التقييم",
      no_material_uncertainty: "لا يوجد عدم تأكد جوهري",
      impact: {
        opt1: "الاستنتاج 1 — أساس الاستمرارية مناسب؛ لا يوجد شك جوهري. تقرير مدقق قياسي (بدون فقرة استمرارية).",
        opt2: "رأي غير معدل مع فقرة منفصلة \"شك جوهري متعلق بالاستمرارية\". انظر النموذج 318(a) لصياغة التقرير.",
        opt3: "رأي متحفظ أو رأي معاكس، بحسب أهمية وانتشار عدم كفاية الإفصاح. انظر النموذج 318(a) لصياغة التقرير.",
        opt4: "رأي معاكس. انظر النموذج 318(a) لصياغة التقرير.",
        opt5: "رأي متحفظ أو امتناع عن الرأي، بحسب طبيعة تحديد نطاق العمل. انظر النموذج 318(a) لصياغة التقرير.",
        dateWarning: "تحذير: تاريخ الاستنتاج بعد تاريخ تقرير المدقق. يوجب معيار 700 ألا يسبق تاريخ تقرير المدقق تاريخ حصوله على أدلة تدقيق كافية ومناسبة.",
        standardHint: "المعيار المُطبَّق يُحدَّد من تاريخ بداية الفترة: بداية الفترة قبل 15-ديسمبر-2026 → معيار 570 (المُنقَّح) مع فحص 12 شهرًا من تاريخ القوائم المالية؛ في أو بعد ذلك التاريخ → معيار 570 (المُنقَّح 2024) مع فحص 12 شهرًا من تاريخ اعتماد القوائم المالية.",
      },
      conclusion: {
        1: "أساس الاستمرارية مناسب؛ لا يوجد شك جوهري",
        2: "أساس الاستمرارية مناسب؛ يوجد شك جوهري والإفصاح كافٍ",
        3: "أساس الاستمرارية مناسب؛ يوجد شك جوهري والإفصاح غير كافٍ",
        4: "استخدام أساس الاستمرارية غير مناسب",
        5: "الإدارة غير راغبة أو غير قادرة على إجراء أو تمديد التقييم",
      },
      standardApplied: "المعيار المطبَّق",
      standardOverrideBanner: "لقد تجاوزت المعيار المُختار تلقائيًا. يرجى تسجيل السبب أدناه — يُكتب التجاوز في سجل التدقيق.",
      reportingImpactLabel: "الأثر على تقرير المراجع",
      reportingImpactEmpty: "لا يوجد أثر على تقرير المراجع — تقرير مدقق قياسي.",
      reportingImpactLinkTo318a: "انظر النموذج 318(a) — تقييم الرأي المعدَّل",
      additionalNotes: "ملاحظات إضافية",
    },
  },
};

export default I18N_BASE_GOING_CONCERN;
